<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

<div class="cont-0">
    
    <div class="cont-1">
        <div class="error-msg" *ngIf="errorMessage">
            *{{errorMessage}}
        </div>
        <form class="frm" [formGroup]="formGroup" novalidate (ngSubmit)="onSubmit(formGroup.value)" #myForm="ngForm"> 
            
                <label for="heading">Title : </label>
                <input type="text" name="heading" formControlName="heading"/>
                
                <label for="amount">Amount : </label>
                <input type="number" name="amount" formControlName="amount"/>
            
            
                <label for="heading">Details : </label>
                <input type="text" name="description" formControlName="description"/>

                <label for="heading">Date : </label>
                <input type="date" name="date" placeholder=" " formControlName="date"/>
            <div class="actions">
                <button type="submit" name="submit" class="btn submit">
                    <i class="material-icons">add_circle_outline</i>
                </button>
                <!-- <button type="submit" name="signUp" class="btn submit" >{{ action | uppercase }}</button> -->
            </div>
        </form>
        <div class="go-back">
            <button class="btn-back" name="back" (click)="goBack()">Go Back</button>
        </div>
    </div>
    </div>